<template>
    <div id="doc_page">
        <div class="page_content">
            <div class="doc_wrap" v-if="share.article!=''">
                <!-- <div class="doc_title" v-html="share.article.question"></div> -->
                <!-- <div class="doc_info">{{ share.article.nick_name }}<span class="doc_type">{{ share.article.app_name }}</span>{{ share.article.update_time }}</div> -->
                <div class="doc_content ql-editor" v-html="share.article.answer"></div>
            </div>
            <el-card class="passward_panel" v-show="showPanel">
                <div class="panel_title">
                    <img class="user_avatar" :src="share.user.avatarurl || df_avatar" ><span class="user_name">{{ share.user.nick_name }}</span>给你<span v-if="share.enable_pwd==1">加密</span>分享了文档
                </div>
                <div class="panel_content" v-if="share.expired==1">
                    <div>文档过期了，不能访问</div>
                </div>
                <div class="panel_content" v-else-if="share.enable_pwd==1">
                    <div class="panel_label">请输入文档分享密码</div>
                    <div class="input_wrap"><el-input style="width:205px;" v-model="keyValue" placeholder="请输入密码"></el-input></div>
                    <div class="btn_wrap"><el-button @click="identifyKeys" style="width:122px;" type="info">确定</el-button></div>
                </div>
            </el-card>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                df_avatar:require("../img/img_icon_17.png"),
                docData:{
                    content:"",
                    zan_nun:0,
                    star_num:0
                },
                share_user_info:{
                    real_name:"Mr.Zhao",
                    avatarurl:"",
                },
                keyValue:"",
                showPanel:false,
                code:'',
                share:{
                    enable_pwd:0,
                    expired:0,
                    user:{},
                    article:{}
                }

            }
        },
        created() {
            this.code = this.$route.query.code || ""
            this.fetch()
        },
        methods: {
            identifyKeys(){
                if(!this.keyValue){
                    this.$toast("请先输入密码");
                }else{
                    this.$http.patch(`/front/aixz/article/share/${this.code}/`,{password:this.keyValue}).then(res =>{
                        if(res.status=='200'){
                            this.showPanel = false
                            this.share.article = res.data
                        }
                    }).catch(res => {
                        this.$message({
                            message: res.result,
                            type: 'error'
                        });
                    })
                }
            },
            save(){
                if(this.share.article.id){
                    this.$http.patch(`/front/aixz/article/0/`,{action:"copyshare", value:this.code}).then(res =>{
                        if(res.status=='200'){
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration:1500
                            });
                        }
                    })
                }
            },
            fetch(){
                this.$http.get(`/front/aixz/article/share/${this.code}/`).then(res =>{
                    if(res.status=='200'){
                        if(res.data.enable_pwd==1||res.data.expired==1){
                            this.showPanel = true
                        }
                        this.share = res.data
                        if(res.data.expired == 1){
                        }else if(res.data.article!=""){

                        }
                    }
                })
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    @import url("/static/quill.snow.css");
    #doc_page{
        .page_content{
            position: relative;
            max-width: 800px;
            min-height: 768px;
            margin: 0 auto;
        }
        .doc_wrap{
            padding: 20px;
            .ql-editor{
                line-height: 1.72;
            }
            .doc_title{
                font-size: 28px;
                font-weight: bold;
                padding-top: 10px;
            }
            .doc_info{
                font-size: 13px;
                padding: 20px 0;
                color: #999;
                .doc_type{
                    color: #07c160;
                    padding: 0 8px;
                }
            }
            .doc_content{
                padding: 0;
            }
        }
        .doc_btn{
            position: absolute;
            top: 0;
            right: -74px;
            border-radius: 5px;
            border: 1px solid #e9e9eb;
            background-color: #fff;
            padding: 6px 11px 0;
            .btn_item{
                padding-top: 8px;
                &:first-child{
                    border-bottom: 1px solid #e9e9eb;
                }
                .btn_icon{
                    width: 20px;
                    display: block;
                    margin: 0 auto;
                }
                .btn_num{
                    text-align: center;
                    font-size: 12px;
                    line-height: 26px;
                }
            }
        }
        .passward_panel{
            position: absolute;
            top: 50%;
            left: 50%;
            max-width: 420px;
            width: 90vw;
            height: 320px;
            transform: translate(-50%,-50%);
            /deep/ .el-card__body{
                padding: 0 32px;
            }
            .panel_title{
                text-align: center;
                border-bottom: 1px dashed #ccc;
                line-height: 68px;
                color: #999;
                .user_avatar{
                    vertical-align: middle;
                    margin: -2px 8px 0 0;
                    border-radius: 50%;
                    width: 16px;
                }
                .user_name{
                    color: #424242;
                    margin-right: 14px;
                }
            }
            .panel_content{
                padding-top: 26px;
                display: flex;
                flex-direction: column;
                align-items: center;
                .panel_label{
                    line-height: 54px;
                }
                .input_wrap{
                    margin-bottom: 24px;
                }
            }
        }
    }
</style>